import React, { useState } from 'react';
import { contactData } from '../data/mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
//import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { MapPin, Mail, Phone, Clock, FileText, Send, CheckCircle } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 3000);
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="py-10 bg-gradient-to-b from-gray-50/50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[#cd2d31]/10 border border-[#cd2d31]/20 rounded-full px-4 py-2 mb-6">
            <span className="text-[#cd2d31] font-semibold text-sm">Get In Touch</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {contactData.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {contactData.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-4 gap-12">
          {/* Contact Information */}
          {/* <div className="lg:col-span-1 space-y-6"> */}
            {/* Address Card */}
            <Card className="border-l-4 border-l-[#0a8ec5] hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center space-x-3 text-[#0a8ec5]">
                  <MapPin className="w-6 h-6" />
                  <span>{contactData.address.title}</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-1 text-gray-700">
                  <p>{contactData.address.line1}</p>
                  <p>{contactData.address.line2}</p>
                  <p className="font-semibold">{contactData.address.line3}</p>
                </div>
              </CardContent>
            </Card>

            {/* Email Card */}
            <Card className="border-l-4 border-l-[#cd2d31] hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center space-x-3 text-[#cd2d31]">
                  <Mail className="w-6 h-6" />
                  <span>Email Us</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  {contactData.emails.map((email, index) => (
                    <a 
                      key={index}
                      href={`mailto:${email}`}
                      className="block text-gray-700 hover:text-[#cd2d31] transition-colors"
                    >
                      {email}
                    </a>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Phone & Hours Card */}
            <Card className="border-l-4 border-l-[#0a8ec5] hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center space-x-3 text-[#0a8ec5]">
                  <Phone className="w-6 h-6" />
                  <span>Call Us</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <a 
                  href={`tel:${contactData.phone}`}
                  className="block text-gray-700 hover:text-[#0a8ec5] transition-colors font-semibold"
                >
                  {contactData.phone}
                </a>
                <div className="flex items-center space-x-2 text-gray-600">
                  <Clock className="w-4 h-4" />
                  <span className="text-sm">{contactData.hours}</span>
                </div>
              </CardContent>
            </Card>

            {/* GST Card */}
            <Card className="border-l-4 border-l-[#cd2d31] hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center space-x-3 text-[#cd2d31]">
                  <FileText className="w-6 h-6" />
                  <span>GST Number</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-mono text-gray-700">{contactData.gst}</p>
              </CardContent>
            </Card>
          {/* </div> */}

          {/* Contact Form */}
          {/* <div className="lg:col-span-2">
            <Card className="shadow-xl border-0">
              <CardHeader>
                <CardTitle className="text-2xl font-bold text-gray-900">Send Us a Message</CardTitle>
                <p className="text-gray-600">Fill out the form below and we'll get back to you within 24 hours</p>
              </CardHeader>
              <CardContent>
                {isSubmitted ? (
                  <div className="text-center py-8">
                    <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Message Sent Successfully!</h3>
                    <p className="text-gray-600">Thank you for your inquiry. We'll get back to you soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Full Name *
                        </label>
                        <Input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                          className="w-full"
                          placeholder="Your full name"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Email Address *
                        </label>
                        <Input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          className="w-full"
                          placeholder="your@email.com"
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Phone Number
                        </label>
                        <Input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="w-full"
                          placeholder="+91 XXXXX XXXXX"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Company Name
                        </label>
                        <Input
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleInputChange}
                          className="w-full"
                          placeholder="Your company name"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Subject *
                      </label>
                      <Input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        className="w-full"
                        placeholder="What can we help you with?"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Message *
                      </label>
                      <Textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        className="w-full"
                        placeholder="Tell us more about your air pollution control requirements..."
                      />
                    </div>

                    <Button
                      type="submit"
                      className="w-full bg-[#cd2d31] hover:bg-[#b02529] text-white py-3 text-lg font-semibold transition-all duration-200 hover:shadow-lg hover:scale-105 group"
                    >
                      <Send className="mr-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                      Send Message
                    </Button>
                  </form>
                )}
              </CardContent>
            </Card>
          </div> */}
        </div>

        {/* {/* Google Maps /}
        <div className="mt-16">
          <Card className="overflow-hidden">
            <CardHeader>
              <CardTitle className="text-xl font-bold text-gray-900 flex items-center space-x-3">
                <MapPin className="w-6 h-6 text-[#0a8ec5]" />
                <span>Find Us Here</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="w-full h-96 bg-gradient-to-br from-[#0a8ec5]/10 to-[#cd2d31]/10 flex items-center justify-center">
                <div className="text-center">
                  <MapPin className="w-16 h-16 text-[#0a8ec5] mx-auto mb-4" />
                  <p className="text-gray-600 font-semibold">Interactive Map</p>
                  <p className="text-gray-500 text-sm">21, Hemanta Basu Sarani, Kolkata 700 001</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div> */}
        {/* Google Maps */}
        <div className="mt-16">
          <Card className="overflow-hidden">
            <CardHeader>
              <CardTitle className="text-xl font-bold text-gray-900 flex items-center space-x-3">
                <MapPin className="w-6 h-6 text-[#0a8ec5]" />
                <span>Find Us Here</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              {/* --- This is the new part --- */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.238421869804!2d88.35128237596599!3d22.57022783307525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02777660232577%3A0xe3379555de160af0!2s21%2C%20Hemanta%20Basu%20Sarani%2C%20B.B.D.%20Bagh%2C%20Kolkata%2C%20West%20Bengal%20700001!5e0!3m2!1sen!2sin!4v1729107147754!5m2!1sen!2sin"
                className="w-full h-96"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps Location of 21, Hemanta Basu Sarani, Kolkata"
              ></iframe>
              {/* --- End of new part --- */}
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;